import { tv } from '@change/ds-utils';

export const RectangleStyles = tv({
	// color-icon-inverse-disabled cannot be used as background color. Hardcoding it.
	base: 'h-[11px] w-[166px] bg-[#e1dde9]',
	variants: {
		loading: {
			true: 'animate-pulse',
			false: '',
		},
		rounded: {
			true: 'rounded-[28px]',
			false: '',
		},
	},
});
